/** CORTEKITANCHO | CORTEKITALTO | CORTEKITFONDO | CORTEKITESP y variantes */
export function isCorteKitCatalog(codigoOrCatalogID?: string | number | null): boolean {
  if (codigoOrCatalogID == null || codigoOrCatalogID === '') return false
  return String(codigoOrCatalogID).toUpperCase().startsWith('CORTEKIT')
}

export function itemUsesCorteKitCatalog(item?: {
  catalogID?: string | number | null
  codigo?: string | null
} | null): boolean {
  if (item == null) return false
  return isCorteKitCatalog(item.catalogID) || isCorteKitCatalog(item.codigo)
}
